/* VidaBar VX sections — tabs, hero slideshow, scrollers, reveal, AJAX add-to-cart.
   Everything is progressive enhancement: without JS, tabs show the first panel,
   forms post to /cart/add and links work. */
(function () {
  if (window.__vxInit) return;
  window.__vxInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Tabs: [data-vx-tabs] > [role=tab][aria-controls] ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-vx-tabs]').forEach(function (tabs) {
      if (tabs.__vx) return; tabs.__vx = true;
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn, focus) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) btn.focus();
      }
      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = buttons[(i + 1) % buttons.length];
          if (k === 'ArrowLeft') n = buttons[(i - 1 + buttons.length) % buttons.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-vx-slides]').forEach(function (box) {
      if (box.__vx) return; box.__vx = true;
      var slides = box.querySelectorAll('.vx-hero__slide');
      var dots = box.querySelectorAll('.vx-hero__dot');
      var tag = box.querySelector('.vx-hero__tag');
      if (slides.length < 2) return;
      var i = 0, timer = null, delay = (parseInt(box.getAttribute('data-vx-slides'), 10) || 5) * 1000;
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
        if (tag) { var t = slides[i].getAttribute('data-tag'); tag.textContent = t || ''; tag.hidden = !t; }
      }
      function play() { if (!reduce) { stop(); timer = setInterval(function () { go(i + 1); }, delay); } }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', play);
      play();
    });
  }

  /* ---------- Scroller arrows ---------- */
  function initScrollers(root) {
    root.querySelectorAll('[data-vx-scroller]').forEach(function (sc) {
      if (sc.__vx) return; sc.__vx = true;
      var track = sc.querySelector('.vx-track');
      var prev = sc.querySelector('.vx-arrowbtn--prev');
      var next = sc.querySelector('.vx-arrowbtn--next');
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * .8; }
      function update() {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(root) {
    root.querySelectorAll('.vx-reveal:not(.is-in)').forEach(function (el, n) {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = Math.min(n % 6, 5) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Kit variant pills update the hidden id + button price ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-vx-variant]');
    if (!input) return;
    var form = input.closest('form'); if (!form) return;
    var id = form.querySelector('input[name="id"]'); if (id) id.value = input.value;
    var price = form.querySelector('[data-vx-price]'); if (price) price.innerHTML = input.getAttribute('data-price-html') || '';
  });

  /* ---------- AJAX add-to-cart → open the cart drawer ---------- */
  function toast(msg) {
    var t = document.querySelector('.vx-toast');
    if (!t) { t = document.createElement('div'); t.className = 'vx-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-vx-atc]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // normal submit → /cart
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number((form.querySelector('[name="quantity"]') || {}).value) || 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function (data) {
        var el = document.querySelector('cart-drawer.drawer'); if (el) el.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vx', cartData: data }); } catch (err) {}
        }
      })
      .catch(function (err) {
        if (err && (err.description || err.message) && err.status) toast(err.description || err.message);
        else form.submit();
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  function initAll(root) { root = root || document; initTabs(root); initHero(root); initScrollers(root); initReveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
